// extracted by mini-css-extract-plugin
export default {"products":"ED-z","card":"FD-z","oosMessaging":"GD-z"};